import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { globalRouters } from '@/router'
// 全局样式
import '@/style/common/index.scss'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <RouterProvider router={globalRouters} />
)